import {
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../../constants/app-constant";
const { V_SOCIAL, TWITTER_INSIGHTS } = VERTICALS;

export const socialSOVWidgetList = [
  {
    type: V_SOCIAL,
    name: "RANKING BY COMPANY",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.SOVNOARanking,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "TREND BY COMPANY",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.SOV_NOA_TREND,
        vertical: [V_SOCIAL],
      },
    ],
  },
];

export const socialWordCloudWidgetList = [
  {
    type: V_SOCIAL,
    name: "Keyword cloud",
    graph_type: GRAPH_TYPES.WORD_CLOUD,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.KeywordCloudNOA,
        vertical: [V_SOCIAL],
      },
    ],
  },
];

export const socialSentimentWidgetlist = [
  {
    type: V_SOCIAL,
    name: "TONALITY BY COMPANY",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TonalityNAORanking,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialCityWidgetList = [
  {
    type: V_SOCIAL,
    name: "World Map",
    graph_type: GRAPH_TYPES.CHOROPLETH,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.WorldMap,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Citywise Insights",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.CitySpecificReport,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialNewCityWidgetList = [
  {
    type: V_SOCIAL,
    name: "World Map",
    graph_type: GRAPH_TYPES.CHOROPLETH,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.WorldMap,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Citywise Insights (For India Only)",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.citywisenew,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialTagWidgetList = [
  {
    type: V_SOCIAL,
    name: "Tag Analysis",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TagBasedTagAnalysis,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Tag Analysis By Entity",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.EntityBasedTagAnalysis,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialLanguageWidgetList = [
  {
    type: V_SOCIAL,
    name: "Top Languages",
    graph_type: GRAPH_TYPES.DOUGHNUT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TopLanguages,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialShareRetweetWidgetList = [
  {
    type: V_SOCIAL,
    name: "Share / Retweet",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.ShareRetweet,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialReplyCommentWidgetList = [
  {
    type: V_SOCIAL,
    name: "Reply / Comment",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.ReplyComment,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialAttachmentWidgetList = [
  {
    type: V_SOCIAL,
    name: "Attachment",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.Attachment,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialLikeWidgetList = [
  {
    type: V_SOCIAL,
    name: "Attachment",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.Like,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
// export const socialAuthorLikeWidgetList = [
//   {
//     type: V_SOCIAL,
//     name: "Author Like",
//     graph_type: GRAPH_TYPES.BAR_VERTICAL,
    
//     filterOption: [
//       {
//         label: "Number of article",
//         value: REPORT_TYPES.AuthorLike,
//         vertical: [V_SOCIAL],
//       },
//     ],
//   },
// ];
export const socialMemberTypeWidgetList = [
  {
    type: V_SOCIAL,
    name: "Member Type",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.MemberType,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialTypeOfPostWidgetList = [
  {
    type: V_SOCIAL,
    name: "Type Of Post",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.TypeOfPost,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialAuthorFollowingWidgetList = [
  {
    type: V_SOCIAL,
    name: "Author Following",
    graph_type: GRAPH_TYPES.TABLE,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.AuthorFollowing,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Author Tweet Count",
    graph_type: GRAPH_TYPES.TABLE,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.AuthorTweetCount,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Author Listed",
    graph_type: GRAPH_TYPES.TABLE,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.AuthorListed,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Author Creation Detail",
    graph_type: GRAPH_TYPES.TABLE,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.AuthorCreated,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Author Like",
    graph_type: GRAPH_TYPES.TABLE,
    
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.AuthorLike,
        vertical: [V_SOCIAL],
      },
    ],
  },
];
export const socialCitySpecificWidgetList = [
  {
    type: V_SOCIAL,
    name: "City Specific Report",
    graph_type: GRAPH_TYPES.TABLE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.CitySpecificReport,
        vertical: [V_SOCIAL],
      },
    ],
  },
];

export const socialPlatformWidgetList = [
  {
    type: V_SOCIAL,
    name: "PLATFORM BY RANKING",
    graph_type: GRAPH_TYPES.BAR_VERTICAL,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.PLATFORM_RANK,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "PLATFORM BY TREND",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.PLATFORM_TREND,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "PLATFORM BY SENTIMENT",
    graph_type: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    filterOption: [
      {
        label: "Number of article",
        value: REPORT_TYPES.PLATFORM_TONALITY,
        vertical: [V_SOCIAL],
      },
    ],
  },
];

export const socialTwitterWidgetList = [
  {
    type: V_SOCIAL,
    name: "X BreakDown",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.TWITTER,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "X BreakDown",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.TWITTER,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "X Metrics",
    graph_type: "",
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.TWITTER_METRICES,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "X Metrics",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.TWITTER_METRICES,
        vertical: [V_SOCIAL],
      },
    ],
  },
];

export const socialLinkedInWidgetList = [
  {
    type: V_SOCIAL,
    name: "LinkedIn BreakDown",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.LINKEDIN,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "LinkedIn BreakDown",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.LINKEDIN,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "LinkedIn Metrics",
    graph_type: "",
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.LINKEDIN_METRICS,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "LinkedIn Metrics",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.INSTAGRAM_METRICS,
        vertical: [V_SOCIAL],
      },
    ],
  },
];

export const socialFacebookWidgetList = [
  {
    type: V_SOCIAL,
    name: "Facebook BreakDown",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.FACEBOOK,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Facebook BreakDown",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.FACEBOOK,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Facebook Metrics",
    graph_type: "",
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.FACEBOOK_METRICS,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Facebook Metrics",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.FACEBOOK_METRICS,
        vertical: [V_SOCIAL],
      },
    ],
  },
];

export const socialInstagramWidgetList = [
  {
    type: V_SOCIAL,
    name: "Instagram BreakDown",
    graph_type: GRAPH_TYPES.PIE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.INSTAGRAM,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Instagram BreakDown",
    graph_type: GRAPH_TYPES.LINE,
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.INSTAGRAM,
        vertical: [V_SOCIAL],
      },
    ],
  },
  {
    type: V_SOCIAL,
    name: "Instagram Metrics",
    graph_type: "",
    filterOption: [
      {
        label: "",
        value: REPORT_TYPES.INSTAGRAM_METRICS,
        vertical: [V_SOCIAL],
      },
    ],
  },
  // {
  //   type: V_SOCIAL,
  //   name: "Instagram Metrics",
  //   graph_type: GRAPH_TYPES.LINE,
  //   filterOption: [
  //     {
  //       label: "",
  //       value: REPORT_TYPES.INSTAGRAM_METRICS,
  //       vertical: [V_SOCIAL],
  //     },
  //   ],
  // },
];
